import APIService from '@/services/APIService';
import CRUDFactory from '@/services/CRUDFactory';

export default {
  ...CRUDFactory('/widgets'),

  create(data) {
    return APIService.post('/widgets/create', data);
  },
  delete(id) {
    return APIService.post('/widgets/delete', { id });
  },
};
